"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsUpdateSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const Feature_1 = require("../Feature");
function ModelsUpdateSwitch() {
    return ((0, jsx_runtime_1.jsxs)(Feature_1.Feature, { type: bridge_schema_1.PreferenceBoolOption.ShowModelUpdatesIndicators, defaultSpoilerHeight: 300, "data-e2e": 'ModelsUpdateSwitch_Feature', children: [(0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.modelUpdates.description), (0, jsx_runtime_1.jsxs)(Warning, { "data-e2e": 'ModelsUpdateSwitch_Warning', children: [(0, jsx_runtime_1.jsx)(OldContentWarningIcon, { name: ui_1.Icons.Warning, "data-e2e": 'ModelsUpdateSwitch_OldContentWarningIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.modelUpdates.affectedIndicator)] }), (0, jsx_runtime_1.jsxs)(Warning, { "data-e2e": 'ModelsUpdateSwitch_Warning', children: [(0, jsx_runtime_1.jsx)(NewerContentWarningIcon, { name: ui_1.Icons.Warning, "data-e2e": 'ModelsUpdateSwitch_NewerContentWarningIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.modelUpdates
                        .newerVersionIndicator)] })] }));
}
exports.ModelsUpdateSwitch = ModelsUpdateSwitch;
const Warning = styled_components_1.default.div `
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 0 0 10px;

  &:first-child {
    margin-top: 20px;
  }
`;
const WarningIcon = (0, styled_components_1.default)(ui_1.Icon) `
  flex-shrink: 0;

  width: 26px;
  height: 22px;
  margin: auto 15px auto 0;
`;
const OldContentWarningIcon = (0, styled_components_1.default)(WarningIcon) `
  color: ${({ theme }) => theme.designSystem.warning};
`;
const NewerContentWarningIcon = (0, styled_components_1.default)(WarningIcon) `
  color: ${({ theme }) => theme.designSystem.darkerAccent};
`;
